/**
 * S5 organisation ID - Goals & Tasks, Key Metrics (goals), Leaderboard, Team Performance badge/streak,
 * and Goals Settings are shown only for this organisation.
 */
export const S5_ORG_ID = '68b2c559f43d78cbf207113b';

/**
 * Additional organisation IDs that also have Goals & Tasks access.
 */
export const GOALS_ALLOWED_ORG_IDS = [
  S5_ORG_ID,
  '69b9203c0ac3dd9c72cde940', // amrish@yopmail.com
  '69b7dae50ac3dd9c72cd59a6', // priyanka2@yopmail.com
  '69381b0ce3beec2d4e921f9e', // hello@teamgrid.ai
];

/**
 * @param {object} user - Auth user object (may have organizationId as object or string)
 * @returns {string|null} Current organisation ID
 */
export function getOrgId(user) {
  if (!user?.organizationId) return null;
  const o = user.organizationId;
  if (typeof o === 'object') return o._id || o.id || null;
  return typeof o === 'string' ? o : null;
}

/**
 * @param {object} user - Auth user object
 * @returns {boolean} True if current user's organisation is S5
 */
export function isS5Organisation(user) {
  const orgId = getOrgId(user);
  return orgId ? true : false;
}
